import * as XLSX from "xlsx";

export interface IReportColumn<T = any> {
  header: string;
  key: keyof T;
  width?: number;
}

/**
 * Generic Excel export. Each module passes its own columns.
 * NOTE: community `xlsx` does not write cell styles (colours), only
 * data, headers and column widths.
 */
export function generateExcelReport<T = any>(
  rows: T[],
  columns: IReportColumn<T>[],
  fileName: string,
  sheetName = "Report",
) {
  const headerRow = columns.map((c) => c.header);
  const dataRows = rows.map((row) => columns.map((c) => row[c.key] ?? ""));

  const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
  worksheet["!cols"] = columns.map((c) => ({ wch: c.width }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}
